module.exports = __webpack_public_path__ + "files/122f48c0d50efdf53d195441f65e5801.png";